function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20.3187 2.36621H11.6689V15.6301H20.3187V2.36621Z",
  fill: "#FF5F00"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.2181 9.00222C12.2169 7.72503 12.5562 6.46433 13.2104 5.31556C13.8645 4.16678 14.8163 3.16001 15.9938 2.37145C14.5355 1.39352 12.7841 0.785401 10.9398 0.6166C9.09561 0.447799 7.23292 0.725124 5.56466 1.41688C3.8964 2.10863 2.48988 3.18691 1.50586 4.52847C0.521833 5.87003 0 7.42075 0 9.00339C0 10.586 0.521833 12.1368 1.50586 13.4783C2.48988 14.8199 3.8964 15.8982 5.56466 16.5899C7.23292 17.2817 9.09561 17.559 10.9398 17.3902C12.7841 17.2214 14.5355 16.6133 15.9938 15.6353C14.816 14.8465 13.8639 13.8394 13.2098 12.6902C12.5556 11.541 12.2165 10.2798 12.2181 9.00222V9.00222Z",
  fill: "#EB001B"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M31.0524 14.2273V13.9555H31.1815V13.8993H30.8547V13.9555H30.9838V14.2273H31.0524ZM31.6868 14.2273V13.8993H31.5879L31.4726 14.1336L31.3572 13.8993H31.2584V14.2273H31.327V13.979L31.4341 14.1922H31.5083L31.6154 13.979V14.2273H31.6868Z",
  fill: "#F79E1B"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M31.9889 8.99956C31.9889 10.5823 31.4669 12.1331 30.4827 13.4747C29.4985 14.8163 28.0918 15.8946 26.4233 16.5863C24.7548 17.2779 22.892 17.5551 21.0476 17.386C19.2033 17.217 17.4519 16.6086 15.9937 15.6303C17.1707 14.8411 18.1222 13.834 18.7765 12.6852C19.4308 11.5363 19.7708 10.2757 19.7708 8.99838C19.7708 7.72107 19.4308 6.46043 18.7765 5.31159C18.1222 4.16275 17.1707 3.1557 15.9937 2.36644C17.4519 1.38821 19.2033 0.779794 21.0476 0.61075C22.892 0.441707 24.7548 0.718853 26.4233 1.41051C28.0918 2.10217 29.4985 3.18042 30.4827 4.52203C31.4669 5.86363 31.9889 7.41445 31.9889 8.99721V8.99956Z",
  fill: "#F79E1B"
});
function SvgMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 18,
    viewBox: "0 0 33 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.af305f83.svg";
export { ForwardRef as ReactComponent };